import { provider } from 'react-ioc';
import { RootStore } from '@store';
import App from './App';

export default provider(RootStore)(App);
